<script lang="ts">
    import { getDashboardCtx } from "../state/dashboard.svelte";
    import { translate } from "@/utils/format";

    const store = getDashboardCtx();
</script>

<div class="referralsEmpty">
    <h5>
        {translate(
            "LANG_PARTNER_EMPTY_TITLE",
            "Completa Stripe para ver métricas avanzadas",
        )}
    </h5>
    <p>
        {translate(
            "LANG_PARTNER_EMPTY_DESC",
            "Cuando tu cuenta de Stripe esté conectada, verás aquí el detalle de instalaciones, suscripciones y usuarios atribuidos.",
        )}
    </p>
    <div class="referralsEmpty__steps">
        <div class="step">
            <span class="dot"></span>
            <span>
                {translate(
                    "LANG_PARTNER_STEP_LINK",
                    "Configura tu enlace y QR",
                )}
            </span>
        </div>
        <div class="step">
            <span class="dot"></span>
            <span>
                {translate(
                    "LANG_PARTNER_STEP_STRIPE",
                    "Conecta Stripe",
                )}
            </span>
        </div>
        <div class="step">
            <span class="dot"></span>
            <span>
                {translate(
                    "LANG_PARTNER_STEP_SHARE",
                    "Comparte creatividades y productos",
                )}
            </span>
        </div>
    </div>
    <button
        type="button"
        class="button --primary"
        onclick={() => store.setSection("payouts")}
    >
        {translate("PARTNER_GATE_CTA", "Ir a Cobros")}
    </button>
</div>
